import makeStyles from '@mui/styles/makeStyles';

export const useSelectStyles = makeStyles(() => ({
  input: {
    height: '36px',
    backgroundColor: '#fafafa',
    boxSizing: 'border-box',
    borderRadius: '5px',
    paddingLeft: 0,
  },
  label: {
    fontSize: '0.8rem',
    transform: 'translate(12px, 9px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(12px, -1px) scale(0.75)',
    },
  },
}));
